<template>
  <div id="HomePage">
    <div id="sidebar">
      <sidebarComponent></sidebarComponent>
    </div>
    <div id="content">
<!--      <keep-alive include="keyboardPart">-->
<!--        <component :is="comName"></component>-->
<!--      </keep-alive>-->
      <keyboardPart ref="keyboardPart" v-show="comName === 'keyboardPart'"></keyboardPart>
<!--      <keyboardTools v-show="comName === 'keyboardTools'" :childARef="childARef"></keyboardTools>-->
      <firmwareUpdate v-show="comName === 'firmwareUpdate'"></firmwareUpdate>
      <PromptPage v-show="comName === 'PromptPage'"></PromptPage>
    </div>
  </div>
</template>

<script>

import EventBus from '@/store/eventBus'
import sidebarComponent from '../components/sidebarComponent'
import keyboardPart from '../components/keyboardPart'
// import keyboardTools from '../components/keyboardTools'
import firmwareUpdate from '../components/FirmwareUpdate.vue'
import PromptPage from '../components/PromptPage.vue'

export default {
  name: 'HomePage',
  components: {
    sidebarComponent,
    keyboardPart,
    // keyboardTools,
    firmwareUpdate,
    PromptPage
  },
  data() {
    return {
      comName: 'keyboardPart',
      isReload: true,
      childARef: '',
    }
  },
  created() {
    if ('hid' in navigator) { // 浏览器支持webHid
      navigator.hid.addEventListener('disconnect', () => {
        // 设置一个标志表示页面即将刷新
        if (this.isReload) {
          location.reload()
        }
        // 在此处执行您的逻辑来处理设备断开事件
      });
    } else {
      this.comName = 'PromptPage'
    }
  },
  mounted() {
    EventBus.$on('navChange',this.getNavChange)
    EventBus.$on('getIsReload',this.getIsReload)
    this.childARef = this.$refs.keyboardPart;
    let theme = localStorage.getItem('data-theme')
    if (!theme) {
      window.document.documentElement.setAttribute('data-theme', 'light')
      EventBus.$emit('themeChange','light')
    } else {
      window.document.documentElement.setAttribute('data-theme', theme)
      EventBus.$emit('themeChange',theme)
    }
  },
  methods: {
    getIsReload(val) {
      this.isReload = val
    },
    getNavChange(val) {
      switch (val) {
        case '0':
          this.comName = 'keyboardPart'
          break;
        case '1':
          this.comName = 'keyboardTools'
          break;
        case '2':
          this.comName = 'firmwareUpdate'
          break;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../style/handle.scss';
  #HomePage {
    width: 100vw;
    height: 100vh;
    background: black;
    @include background_color('background_color_main');
    display: flex;
    justify-content: space-between;
    #sidebar {
      width: 15vw;
      height: 100vh;
    }
    #content {
      width: 85vw;
      height: 100vh;
      box-sizing: border-box;
      padding: 0.1rem;
      overflow: auto;
    }
  }
</style>
